<template>
  <div>
    <h3 style="margin-bottom: 0;">Edit Placement Details</h3>
    <hr style="margin-bottom: 0px;">
    <div class="row">
      <div class="col-lg-6 px-4 mb-4">
        <!-- <h4 class="mt-3">Logistics</h4>
        <hr> -->
        <label style="">Which of these do you currently have that are valid (less than 1 year old) requirements?* (Check all that apply)</label>
        <div class="form-check" v-for="(document, index) in documentsOptions" :key="'Document'+index">
          <input class="form-check-input" type="checkbox" :value="document" v-model="documents"/>
          <label class="form-check-label">{{ document }}</label>
        </div>
        <label>Available Start Date*</label>
        <datepicker class="form-control" v-model="startDate" :disabled-dates="disabledDates" style="padding: .37rem .75rem; line-height: 1;"></datepicker>
        <label style="">Days available?* (Check all that apply)</label>
        <div class="form-check" v-for="(day, index) in daysOptions" :key="'Day'+index">
          <input class="form-check-input" type="checkbox" :value="day" v-model="days"/>
          <label class="form-check-label">{{ day }}</label>
        </div>
      </div>
      <div class="col-lg-6 px-4">
        <label>How Long Are You Able to Commit?*</label>
        <input type="text" class="form-control" placeholder="" v-model="committment">
        <label>How Many Hours Per Week Are You Looking For?*</label>
        <input type="text" class="form-control" placeholder="" v-model="hours">
        <label>Please Note Any Schedule Considerations Such As School/Current Job Schedule*</label>
        <input type="text" class="form-control" placeholder="" v-model="schedule">
        <label style="">Describe Your Ideal Nanny Family*</label>
        <small style="display: block;" class="mb-1">Age & number of children, personality of parents, schedule, morals, values, etc.</small>
        <textarea rows="5" class="form-control" v-model="familyDescription"></textarea>
        <div class="form-group form-check mb-1 mt-4">
          <input class="form-check-input" type="checkbox" :value="true" v-model="activeProfile" style="margin-top: 4px;">
          <label class="form-check-label" style="text-align: left; cursor: pointer; margin-top: 0;" @click="activeProfile = !activeProfile">
            Do you currently have an active profile on any Nanny job sites?*
          </label>
        </div>
        <label style="margin-top: 0;">If yes, which site?</label>
        <input type="text" class="form-control" placeholder="" v-model="jobSite">
        <label>How Did You Hear About The Nanny Company Inc.?*</label>
        <input type="text" class="form-control" placeholder="" v-model="marketingSource">
      </div>
    </div>


    <hr>
    <button class="mylisting-button dark-button" style="display: block; margin-left: auto;" @click="save()">Save</button>
  </div>
</template>

<script>
import axios from 'axios'
import Datepicker from 'vuejs-datepicker'; // https://www.npmjs.com/package/vuejs-datepicker

export default {
  components: {
    Datepicker, // https://www.npmjs.com/package/vuejs-datepicker
  },
  props: ['user'],
  data() {
    return {
      documents: [],
      documentsOptions: [],
      startDate: null,
      days: [],
      daysOptions: [],
      committment: '',
      hours: '',
      schedule: '',
      familyDescription: '',
      activeProfile: false,
      jobSite: '',
      marketingSource: '',
    }
  },
  created() {
    this.documentsOptions = this.$store.getters.documentsOptions
    this.daysOptions = this.$store.getters.days

    this.documents = this.user.features
    if (this.user.available_date) {
      this.startDate = new Date(this.user.available_date)
    }
    this.days = this.user.preferences2
    this.committment = this.user.text6
    this.hours = this.user.text7
    this.schedule = this.user.text8
    this.familyDescription = this.user.text1
    this.activeProfile = this.user.boolean_selector3
    this.jobSite = this.user.text9
    this.marketingSource = this.user.marketing_source
  },
  computed: {
    disabledDates() {
      // Disable all the dates before today so that they can't be selected and someone can't post an event in the past
      // https://www.npmjs.com/package/vuejs-datepicker#usage
      let today = new Date()
      let disabledDates = {
        to: new Date(today.getFullYear(), today.getMonth(), today.getDate())
      }
      return disabledDates
    },
  },
  methods: {
    save() {
      if (this.startDate) {
        this.startDate = this.dateInDjangoFormat(this.startDate)
      }

      axios.patch('/api/people/'.concat(this.user.id.toString()).concat('/'), {
        features: this.documents,
        available_date: this.startDate,
        preferences2: this.days,
        text6: this.committment,
        text7: this.hours,
        text8: this.schedule,
        text1: this.familyDescription,
        boolean_selector3: this.activeProfile,
        text9: this.jobSite,
        marketing_source: this.marketingSource,
      })
        .then(res => {
          // this.$emit('professionalInfoSaved')
          this.$emit('infoSaved')
        })
        .catch(error => {
          console.log(error)
        })
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/candidates/profile/DesiredRoleForm.vue